import React from 'react';

const Avatar = ({
  src,
  width = 38,
  height = 38,
  className = '',
  ...others
}) => (
  <img
    className={`c-avatar u-img-round ${className}`}
    alt="User avatar"
    src={src}
    {...others}
    width={width}
    height={height}
  />
);

export default Avatar;



// WEBPACK FOOTER //
// ./src/common/Avatar.js